import { Image } from '@rsa-digital/evo-shared-components/commonTypes/image';
import ImageGallery from '@rsa-digital/evo-shared-components/components/ImageGallery';
import { graphql } from 'gatsby';
import React from 'react';
import { processImageAsset } from 'helpers/csTypeProcessors';
import { CsAsset } from 'types/contentStack';

type ImageGalleryBlockProps = {
  image_gallery: {
    first_image: CsAsset;
    second_image: CsAsset;
    third_image: CsAsset;
  };
};

export const query = graphql`
  fragment ImageGalleryBlock on cs__image_gallery {
    first_image {
      ...Asset
    }
    second_image {
      ...Asset
    }
    third_image {
      ...Asset
    }
  }
`;

const ImageGalleryBlock: React.FC<ImageGalleryBlockProps> = ({ image_gallery }) => {
  const processImagesToList = (assetList: CsAsset[]): Image[] => {
    const imageList = assetList.map((asset) => processImageAsset(asset));
    return imageList.filter((element): element is Image => !!element);
  };

  const imageArray = [
    image_gallery.first_image,
    image_gallery.second_image,
    image_gallery.third_image,
  ];
  const images = processImagesToList(imageArray);

  return (
    <div data-cy="ImageGallery">
      <ImageGallery images={images} />
    </div>
  );
};

export default React.memo(ImageGalleryBlock);
